"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduledBlastListItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class ScheduledBlastListItemDto {
  constructor() {
    this.openPeekToastOnClick = true;
  }
}
exports.ScheduledBlastListItemDto = ScheduledBlastListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ScheduledBlastListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Date)], ScheduledBlastListItemDto.prototype, "scheduledAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: enums_1.ScheduledBlastStatus
}), __metadata("design:type", String)], ScheduledBlastListItemDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ScheduledBlastListItemDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ScheduledBlastListItemDto.prototype, "radius", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], ScheduledBlastListItemDto.prototype, "openPeekToastOnClick", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)({
  enum: ['none', 'venuePeek', 'eventsTab', 'upcomingEvent']
}), __metadata("design:type", String)], ScheduledBlastListItemDto.prototype, "deepLinkTarget", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)(), __metadata("design:type", Object)], ScheduledBlastListItemDto.prototype, "deepLinkVenueSpecialPublicId", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)(), __metadata("design:type", Object)], ScheduledBlastListItemDto.prototype, "scheduledDate", void 0);
//# sourceMappingURL=ScheduledBlastListItem.dto.js.map